import {default as init} from "sdbbJsAssets/chart/charts";

export default function () {
    init();
}